import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./ItemsBlock.module.scss";
import Box from "../Box";
import { showTitleWithDots } from "../utils";

const ItemsBlock = ({ handleLinkClick, items }) => {
  const isLastLevel = items.some(el => !!el?.menu);

  return (
    <div className={styles.itemsBlock}>
      {isLastLevel ? (
        <div className={styles.boxWrap}>
          {items.map(item => (
            <div className={cn(styles.itemsWrap, { [styles.isBig]: item?.menu?.length > 6 })}>
              <div className={styles.title}>
                <span>{item.title}</span>
                <div />
              </div>
              {item.menu ? (
                <Box items={item.menu} handleLinkClick={handleLinkClick} className={styles.border} />
              ) : (
                <div
                  className={styles.item}
                  role="button"
                  tabIndex="0"
                  onMouseEnter={e => showTitleWithDots(e, item.title, true)}
                  onClick={e => handleLinkClick(e, item.url, item.target, item.isInternalLink)}
                >
                  <span>{item.title}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <Box items={items} handleLinkClick={handleLinkClick} />
      )}
    </div>
  );
};

ItemsBlock.propTypes = {
  handleLinkClick: PropTypes.func.isRequired,
  items: PropTypes.object.isRequired
};

export default ItemsBlock;
